module.exports = __webpack_public_path__ + "media/images/shared/icon_shopping_black-459c0b171ec02b84494bf0d9ad66c70d.png";